export default __webpack_public_path__ + "static/media/possibility.81886ea6.png";